module.exports = __webpack_public_path__ + "static/media/camera-lens-cap4.c796c2a0.aac";